import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Footer} from '@wr/ui-patterns';
import config from '../../../config';

const mapConfigToProps = () => {
    const {brexit} = config.features;

    return {
        brexit
    };
};

const mapStateToProps = state => {
    const {commonPageData} = state;
    const {localisation, customer} = commonPageData;
    const {countryCode} = customer;
    const translations = localisation.translations.footer;

    return {
        translations,
        countryCode
    };
};

export const ConnectedFooter = connect(mapStateToProps, mapConfigToProps)(Footer);

export default withRouter(ConnectedFooter);
